class HeaderDefault {
    constructor() {
        document.addEventListener(
            "alpine:init",
            () => {
                Alpine.data("alpinePage", () => ({}));
            },
            { once: true },
        );
    }
}

new HeaderDefault();
